import { FC } from "react"
import { ContainerWrapper } from "src/components/wrappers"
import { CompanyCreateFormContainer } from "./CompanyCreateForm"

export const CompanyPage: FC = () => (
	<ContainerWrapper>
		<CompanyCreateFormContainer />
	</ContainerWrapper>
)
